import { NgModule } from '@angular/core';

import { TmsLibModule } from '../tms-shared';
import { BaseViewStockComponent } from './components';

const components = [BaseViewStockComponent];

@NgModule({
  imports: [TmsLibModule],
  declarations: components,
  exports: [TmsLibModule, ...components],
})
export class TmsAppScannerSharedModule {}
